import { render, staticRenderFns } from "./CaseAddDataRequest.vue?vue&type=template&id=54694112&scoped=true&lang=pug&"
import script from "./CaseAddDataRequest.vue?vue&type=script&lang=js&"
export * from "./CaseAddDataRequest.vue?vue&type=script&lang=js&"
import style0 from "./CaseAddDataRequest.vue?vue&type=style&index=0&id=54694112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54694112",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VCombobox,VForm,VIcon,VRow})
